exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/nivedha/Documents/github/sandbox/src/sppu-beta/src/app/academics/langauge.component.css
// module id = ../../../../../src/app/academics/langauge.component.css
// module chunks = main